// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, type Environment, graphql} from 'react-relay'

import type {
  createItemPickerLabelMutation,
  createItemPickerLabelMutation$data,
} from './__generated__/createItemPickerLabelMutation.graphql'

export function commitCreateLabelMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {
    repositoryId: string
    color: string
    name: string
  }
  onError?: (error: Error) => void
  onCompleted?: (response: createItemPickerLabelMutation$data) => void
}) {
  return commitMutation<createItemPickerLabelMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation createItemPickerLabelMutation($input: CreateLabelInput!) @raw_response_type {
        createLabel(input: $input) {
          label {
            id
            name
            nameHTML
            color
            description
            url
          }
        }
      }
    `,
    variables: {input},
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
